import { useBlockProps, InnerBlocks } from '@wordpress/block-editor';
import { getWrapperProps } from './styles';

/**
 * The region is placed by the root Tabs grid, which selects it on `data-area`.
 * The attribute rather than a modifier class keeps the CSS keyed to one
 * vocabulary that both the preset definition and the stylesheet share.
 */
export default function Save( { attributes } ) {
	const blockProps = useBlockProps.save( getWrapperProps( attributes ) );

	return (
		<div { ...blockProps }>
			<InnerBlocks.Content />
		</div>
	);
}
